<!-- Contact Us Start -->
<section class="section" id="contact">
  <div class="container space-around">
    <div class="row justify-content-center">
      <div class="col-lg-12" style="padding-bottom:10rem !important">
        <div class="title text-left mb-5">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="row">
                <div class="col-lg-4">
                  <div class="contact-address">
                    <h4 class="text-dark mb-4">Contact Info</h4>
                    <p class="text-muted f-15">If you have any questions, just fill in the contact form and we will
                      answer you
                      shortly.</p>

                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="contact-address">
                        <h5 class="text-dark mb-3 f-16">USA</h5>
                        <p class="text-muted f-15"><a class="text-muted" href="tel:2148811184">(214) 881 1184</a> <br />
                          <a class="text-muted" href="mailto:info@bemddops.com">info@bemddops.com</a>
                        </p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="contact-address">
                        <h5 class="text-dark mb-3 f-16">GHANA</h5>
                        <p class="text-muted f-15"><a class="text-muted" href="tel:+233505311297">(+233) 50 531
                            1297</a><br />
                          <a class="text-muted" href="mailto:info@bemddops.com">info@bemddops.com</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-7 offset-lg-1">
                  <div class="custom-form mt-4 mt-lg-0">
                    <div id="message"></div>
                    <form [formGroup]="createContactForm">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="form-group app-label">
                            <label for="name">Name</label>
                            <input name="name" type="text" class="form-control" placeholder="Enter your name.."
                              [formControlName]="'name'">
                            <div
                              *ngIf="createContactForm.get('name').hasError('required') && createContactForm.get('name').touched">
                              <small class="text-danger">Name is required</small>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group app-label">
                            <label for="email">Email address</label>
                            <input name="email" type="email" class="form-control" placeholder="Enter your email.."
                              [formControlName]="'email'">
                            <div
                              *ngIf="createContactForm.get('email').hasError('required') && createContactForm.get('email').touched">
                              <small class="text-danger">Email is required</small>
                            </div>
                            <div
                              *ngIf="createContactForm.get('email').hasError('email') && createContactForm.get('email').touched">
                              <small class="text-danger">Please enter valid email</small>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group app-label">
                            <label for="subject">Subject</label>
                            <input type="text" class="form-control" placeholder="Enter Subject.."
                              [formControlName]="'subject'">
                            <div
                              *ngIf="createContactForm.get('subject').hasError('required') && createContactForm.get('subject').touched">
                              <small class="text-danger">Subject is required</small>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group app-label">
                            <label for="comments">Message</label>
                            <textarea name="comments" rows="3" class="form-control" placeholder="Enter message.."
                              [formControlName]="'message'"></textarea>
                            <div
                              *ngIf="createContactForm.get('message').hasError('required') && createContactForm.get('message').touched">
                              <small class="text-danger">Message is required</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <button type="submit" name="send" class="btn submit-button" (click)="send()">Send Message <i
                              class="mdi mdi-telegram ml-2"></i></button>
                          <div id="simple-msg"></div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="svg-container-2">
    <svg viewBox="0 0 1440 125" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="719.5" cy="222" rx="808.5" ry="222" fill="#34E3B2" />
    </svg>
  </div>

</section>
<!-- Contact Us End -->
